<template>
  <v-slide-y-transition mode="out-in">
    <v-container class="chat-drawer-container fluid pt-0 mb-4">      
      <v-card>
        <v-toolbar color="green" dark>
          <v-toolbar-title class="subheading">Upload Excel or Spreadsheet</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <v-tabs
            slot="extension"
            v-model="tabs"
            centered            
            slider-color="yellow"
          >
            <v-tab :key="1" :href="`#tab-1`">
              Upload Data
            </v-tab>
            <v-tab :key="2" :href="`#tab-2`">
              Download Template
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item :key="1" :value="`tab-1`">
              <v-card flat>
                <v-card-text>
                  <div class="DashboardContainer"></div>              
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="2" :value="`tab-2`">
              <v-card flat>
                <v-card-text>      
                  <v-container grid-list-xl fluid pa-0>
                    <v-layout row wrap grid-list-xl fluid>
                      <v-flex lg6 sm6 xs12>
                        <v-card pa-0 flat>
                          <v-text-field                          
                          solo
                          append-icon="search"
                          placeholder="Search Kelurahan"
                          v-model="kelurahanSearch"
                          hide-details              
                          ></v-text-field>                                            
                          <v-card-text class="pa-0">
                            <v-data-table                
                              :headers="kelurahans.headers"               
                              :items="kelurahans.data"
                              :loading="loading"
                              :rows-per-page-items="[{text:'All','value':-1}]"
                              hide-actions                
                              item-key="id">
                              <template slot="items" slot-scope="props">
                                <tr class="cursor" @click="selectKelurahan(props)">                                
                                  <td>{{ props.item.id }}</td>
                                  <td>{{ props.item.name }}</td>  
                                  <td>{{ props.item.kecamatan_id }}</td>                                
                                </tr>
                              </template>
                            </v-data-table>
                          </v-card-text>
                          <v-card-text>
                            <v-chip outline color="primary" style="float:left">Total &nbsp;<strong> {{kelurahans.count}}</strong></v-chip>                 
                             <div class="text-xs-right">
                                <v-pagination
                                  v-model="kelurahans.page"
                                  v-bind:length="kelurahans.length"
                                  v-bind:total-visible="5"
                                  circle
                                ></v-pagination>
                              </div>
                          </v-card-text>
                        </v-card>  
                      </v-flex>
                      <v-flex lg6 sm6 xs12 v-if="kelurahan">
                        <v-card>
                          <v-toolbar flat>
                            <span class="title">{{kelurahan.name}}</span>
                          </v-toolbar>
                          <v-card-text class="pa-0">                            
                            <div class="pa-0 branch-scroll nopadding">
                              <v-data-table
                                :headers="kompetisis.headers"
                                :search="kompetisiSearch"
                                :items="kompetisis.items"
                                :loading="loading"
                                :rows-per-page-items="[25,50,{text:'All','value':-1}]"                                
                                hide-actions
                                item-key="id"                                                            
                                >
                                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                                <template slot="items" slot-scope="props"> 
                                  <td class="pa-2 pr-3 pl-3">
                                    <v-btn large v-bind:color="props.item.color" v-bind:loading="props.item.loading" @click="setTemplate(props)" block dark>
                                      <v-icon left medium>archive</v-icon> {{props.item.name}}
                                    </v-btn>                                    
                                  </td>                                  
                                </template>
                              </v-data-table>
                            </div>                              
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex lg12 sm12 xs12 v-if="template.name">
                        <table class="table tabular" id="template">
                          <tbody>
                            <tr>
                              <td :style="'color:#fff; background:'+template.color" colspan="2">Kompetisi</td>
                              <td :style="'color:#fff; background:'+template.color">{{template.id}}</td>
                              <th :style="'color:#fff; text-align:left; background:'+template.color" :colspan="template.tps.length">{{template.name}}</th>
                            </tr>
                            <tr>
                              <td style="background:#C3C3C3" colspan="2">Kelurahan</td>                              
                              <td style="background:#C3C3C3">{{kelurahan.id}}</td>
                              <td style="background:#C3C3C3" :colspan="template.tps.length">{{kelurahan.name}}</td>
                            </tr>
                            <tr><td :colspan="template.tps.length+3"></td></tr>
                            <tr>
                              <th rowspan="3">ID.</th>
                              <th rowspan="3">No.</th>
                              <th rowspan="3">Nama Calon</th>
                              <td v-for="(tp, i) in template.tps"><small>{{tp.id}}</small></td>                              
                            </tr>
                            <tr><th :colspan="template.tps.length">Daftar TPS</th></tr>
                            <tr><th v-for="(tp, i) in template.tps">{{tp.no}}</th></tr>
                            <tr><td></td><td style="background:#C3C3C3" :colspan="template.tps.length + 2">I. Data Suara per Calon</td></tr>
                            <template v-for="(calon, i) in template.calons">                              
                              <tr>
                                <td><small>{{calon.id}}</small></td>
                                <th :style="'color:#fff;background:'+calon.color">{{calon.no}}</th>
                                <td :style="'color:#fff;background:'+calon.color"><strong>{{calon.akronim}}</strong></td>
                                <template v-if="template.mode === 2">
                                  <td :style="'color:#fff;background:'+calon.color" v-for="(tp, i) in template.tps"></td>
                                </template>
                                <template v-else>
                                  <td v-for="(tp, i) in template.tps"></td>
                                </template>
                              </tr>
                              <tr v-if="calon.child" v-for="(child) in calon.child">
                                <td><small>{{child.id}}</small></td>
                                <th></th>
                                <td>{{child.no}}. {{child.name}}</td>
                                <td v-for="(tp, i) in template.tps"></td>
                              </tr>
                            </template> 
                            <tr><td></td><td style="background:#C3C3C3" :colspan="template.tps.length + 2">II. Data Penggunaan Surat Suara</td></tr>
                            <tr>
                              <td colspan="2">tdk_sah</td>
                              <td>Jumlah suara tidak sah</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                            <tr>
                              <td colspan="2">tdk_digunakan</td>
                              <td>Jumlah surat suara yang tidak digunakan</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                            <tr>
                              <td colspan="2">rusak</td>
                              <td>Jumlah surat suara yang dikembalikan pemilih karena rusak</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                            <tr>
                              <td colspan="2">dpt</td>
                              <td>Pemilih terdaftar dalam Daftar Pemilih Tetap (DPT)</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                            <tr>
                              <td colspan="2">dpph</td>
                              <td>Pemilih terdaftar dalam Daftar Pemilih Pindahan (DPPh)</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                            <tr>
                              <td colspan="2">dptb</td>
                              <td>Pemilih dari Daftar Pemilih Tambahan (DPTb)/ Pengguna KTP elektronik/ Surat Keterangan</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                            <tr>
                              <td colspan="2">pen_dpt</td>
                              <td>Penggunaan hak pilih dalam Daftar Pemilih Tetap (DPT)</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                            <tr>
                              <td colspan="2">pen_dpph</td>
                              <td>Penggunaan hak pilih dalam Daftar Pemilih Pindahan (DPPh)</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                            <tr>
                              <td colspan="2">pen_dptb</td>
                              <td>Penggunaan hak pilih dalam Daftar Pemilih Tambahan (dptb)/ Pengguna KTP elektronik/ Surat Keterangan</td>
                              <td v-for="(tp, i) in template.tps"></td>
                            </tr>
                          </tbody>
                        </table>
                      </v-flex>
                    </v-layout>
                  </v-container>  
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>          
        </v-card-text>
      </v-card>      
    </v-container>
  </v-slide-y-transition>  
</template>
<script>
import Table2Excel from 'table2excel.js';  
import Model       from '@/apps/frc/models/Hitung';    
import Interface   from '@/util/interface';
import 'uppy/dist/uppy.min.css';
const _  = require('lodash');
const model = new Model();
const api = Interface.biz4;

  
export default {
  components: {
    
  },
  data () {
    return {
       tabs: 'tab-1',
       kelurahanSearch:null,
       kelurahans:{data:[], page:1, count:0, length:1, headers: [
            { text: 'ID',   value: 'id'  },
            { text: 'Name', value: 'name'},
            { text: 'Kecamatan ID', value: 'kecamatan_id'},            
          ]
        },
       loading:false,
       kelurahan:null,
       kompetisiSearch:null,
       template:{},
       kompetisis : {
        headers: [              
          { text: 'Click Button Bellow for Download', value: 'name', align:'center', sortable:false}
        ],
        items: []
      },
      uploadFile:[]
    };
  },
  watch:{
    kelurahanSearch: function(value){
      var ctx = this; setTimeout(function(){
        if(value === ctx.kelurahanSearch){
          ctx.setKelurahans();
        }
      }, 700);      
    },           
  },
  computed: {
    
  },
  mounted(){
    this.setUploads(); this.setKelurahans(); 
    this.$watch(['kelurahans','page'].join('.'), (newVal)=>{
       this.setKelurahans();
    });
    this.init();
  },
  methods:{
    init(){
      
    },       
    
    setTemplate(props){
      props.item.loading = true; this.template = {};
      model.xlTemplate({kompetisi_id:props.item.id, kelurahan_id:this.kelurahan.id}).then(res=>{
        if(res.status === 200){
          this.template = res.data;   
          const ctx=this; setTimeout(function(){
            props.item.loading = false;
            new Table2Excel('#template').export(props.item.name+'_'+ctx.kelurahan.name);            
          }, 300)          
        } else {
          window.getApp.$emit('showSnackbar', {
              show : true,
              text : 'No Data Result',
              color: 'orange'
          });
          props.item.loading = false;
        }
        
      });
    },
    
    setKelurahans(){
      this.loading = true;          
      model.kelurahans({'KelurahanSearch[name]':this.kelurahanSearch, page:this.kelurahans.page}).then(resp=>{                      
        this.kelurahans.data  = resp.data.data;                
        this.kelurahans.count = resp.data.count;   
        this.kelurahans.length  = Math.ceil(this.kelurahans.count/10);
        this.loading = false;        
      }); 
    },
    
    selectKelurahan(props){     
      this.kelurahan = props.item;      
      this.loading = true;
      model.kompetisisByKelurahan({kelurahan_id:props.item.id}).then(res => {          
          this.kompetisis.items = [];
          res.data.forEach(item=>{
            item.loading = false;
            this.kompetisis.items.push(item);
          });      
          this.loading = false;
      });
    },
    
    setUploads(){
      const Uppy = require('@uppy/core')
      const Dashboard = require('@uppy/dashboard')
      const XHRUpload = require('@uppy/xhr-upload')
      //const GoogleDrive = require('@uppy/google-drive')
      //const Dropbox = require('@uppy/dropbox')
      //const Instagram = require('@uppy/instagram')
      //const Webcam = require('@uppy/webcam')
      //const Tus = require('@uppy/tus')
      
      const rest = api.setter('frc/hitung/xl-upload');
      const uppy = Uppy({
        debug: false,
        autoProceed: false,
        restrictions: {
          maxFileSize: 100000000,
          maxNumberOfFiles: 20,
          minNumberOfFiles: 1,
          allowedFileTypes: ['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
          //allowedFileTypes: ['image/*', 'video/*']
        }
      })
      .use(Dashboard, {
        trigger: '.UppyModalOpenerBtn',
        inline: true,
        target: '.DashboardContainer',
        replaceTargetContent: true,
        showProgressDetails: true,
        note: 'Excel or Spreadsheet only, 1–20 files, up to 100 MB',
        height: 350,
        width:'100%',
        metaFields: [
          { id: 'name', name: 'Name', placeholder: 'file name' },
          { id: 'caption', name: 'Caption', placeholder: 'describe what the file is about' }
        ],
        browserBackButtonClose: true
      })
      //.use(GoogleDrive, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
      //.use(Dropbox, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
      //.use(Instagram, { target: Dashboard, serverUrl: 'https://companion.uppy.io' })
      //.use(Webcam, { target: Dashboard })
      //.use(Tus, { endpoint: 'https://master.tus.io/files/' })
      .use(XHRUpload, {
        endpoint: rest.endpoint,
        headers: rest.headers,
        formData: true,
        fieldName: 'file',        
      })
      uppy.on('complete', (result) => {
        //console.log('successful files:', result.successful);
        //console.log('failed files:', result.failed);        
      });      
    },
        
  }
};
</script>
<style>
.uppy-Dashboard-poweredBy {
    display: none!important;
    text-align: center!important;
    font-size: 11px!important;
    color: #939393!important;
    text-decoration: none!important;
    margin-top: 8px!important;
}

.table {
  border-collapse: collapse;
}

.table th,.table td {
  border: 1px solid black;
  padding: 5px 8px;
}
#template{display:none}
</style>

